enum PlayPositions {
  GOALKEEPER = "GOALKEEPER",
  LEFT_FULLBACK = "LEFT_FULLBACK",
  CENTER_BACK = "CENTER_BACK",
  LEFT_CENTER_BACK = "LEFT_CENTER_BACK",
  RIGHT_CENTER_BACK = "RIGHT_CENTER_BACK",
  RIGHT_FULLBACK = "RIGHT_FULLBACK",
  CENTER_MIDFIELDER = "CENTER_MIDFIELDER",
  LEFT_CENTER_MIDFIELDER = "LEFT_CENTER_MIDFIELDER",
  RIGHT_CENTER_MIDFIELDER = "RIGHT_CENTER_MIDFIELDER",
  DEFENSIVE_MIDFIELDER = "DEFENSIVE_MIDFIELDER",
  ATTACKING_MIDFIELDER = "ATTACKING_MIDFIELDER",
  STRIKER = "STRIKER",
  LEFT_WINGER = "LEFT_WINGER",
  RIGHT_WINGER = "RIGHT_WINGER",
};

export default PlayPositions;